<script setup>
</script>
<template>
    <div class="grid grid-cols-1 gap-3 animate-pulse">
        <div class="grid grid-cols-2 gap-2 py-3">
            <div class="flex flex-col gap-3 justify-center h-[42px] col-span-2">
                <div class="w-[80px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
                <div class="w-[250px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
            </div>
            <div class="col-span-2 w-full h-[1px] bg-[#EAECF0]"></div>
            <div class="flex gap-5 col-span-2">
                <div v-for="i in 2" class="flex flex-col gap-3 justify-center h-[42px] w-full">
                    <div class="w-[80px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
                    <div class="w-full h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
                </div>
            </div>
        </div>
        <div class="grid grid-cols-2 gap-5 py-3">
            <div v-for="i in 2" class="flex flex-col gap-3 justify-center h-[42px]">
                <div class="w-[80px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
                <div class="w-full h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
            </div>
        </div>
        <div class="py-3 flex flex-col gap-3">
            <div class="flex gap-3 justify-between h-[23px] items-center">
                <div class="w-[250px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
                <div class="w-[80px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
            </div>
            <div class="flex gap-3 justify-between h-[23px] items-center">
                <div class="w-[250px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
                <div class="w-[80px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
            </div>
            <div class="flex gap-3 justify-between h-[23px] items-center">
                <div class="w-[250px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
                <div class="w-[80px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
            </div>
            <div class="flex gap-3 justify-between h-[23px] items-center">
                <div class="w-[250px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
                <div class="w-[80px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
            </div>
            <div class="w-full h-[1px] bg-[#EAECF0]"></div>
            <div class="flex gap-3 justify-between h-[23px] items-center">
                <div class="w-[250px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
                <div class="w-[80px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
            </div>
        </div>
    </div>
</template>